$.validator.setDefaults({
    errorElement: 'span',
    errorClass: 'sp-input-error',
    wrapper: 'div',
});